import React from "react";

export default function AboutOwner() {
  return (
    <React.Fragment>
      <div className="py-5">
        <div className="container">
          <p>This is just a practice project for the owner to upskill.</p>
          <p>
            It uses React.js, React-router, context api, styled-components
            Paypal api, etc.
          </p>
          <p>Feel free to play with all the features.</p>
          <p>
            Source code is available on{" "}
            <a href="https://github.com/ryu9827/e-commerce">GitHub repo</a>
          </p>
        </div>
      </div>
    </React.Fragment>
  );
}
